import { render, staticRenderFns } from "./EnforcePassword.vue?vue&type=template&id=566d1ca5&"
import script from "./EnforcePassword.vue?vue&type=script&lang=js&"
export * from "./EnforcePassword.vue?vue&type=script&lang=js&"
import style0 from "./EnforcePassword.vue?vue&type=style&index=0&id=566d1ca5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports